<template>
  <!--콘텐츠 영역-->
  <div
    id="sub_contents"
    class="sub_contents"
  >
    <a href="#sub_contents" id="top_btn"></a>

    <div class="site_map_title">
      <h1>사이트맵</h1>
    </div>

    <div class="site_map_box">
      <div class="site_map_subtitle">
        <h3>주요사업</h3>
      </div>
      <div class="site_map_contents">
        <ul>
          <li><a href="/business/educationsupport" class="">장학생선발</a></li>
          <li><a href="/business/planningbusiness" class="">기획사업</a></li>
          <li><a href="/business/scholarshipselection" class="">교육학술후원</a></li>
        </ul>
      </div>
    </div>

    <div class="site_map_box">
      <div class="site_map_subtitle">
        <h3>재단소식</h3>
      </div>
      <div class="site_map_contents">
        <ul>
          <li><a href="/notice/noticelist" class="">공지사항</a></li>
          <li><a href="/notice/newslist" class="">소식</a></li>
        </ul>
      </div>
    </div>

    <div class="site_map_box">
      <div class="site_map_subtitle">
        <h3>재단소개</h3>
      </div>
      <div class="site_map_contents">
        <ul>
          <li><a href="/intro/establishment">설립취지</a></li>
          <li><a href="/intro/history">연혁</a></li>
          <li><a href="/intro/location">오시는길</a></li>
        </ul>
      </div>
    </div>

    <div class="site_map_box">
      <div class="site_map_subtitle">
        <h3>유관기관</h3>
      </div>
      <div class="site_map_contents">
        <ul>
          <li><a href="https://songwonart.org/" target="blank_">송원아트센터</a></li>
          <li><a href="https://home.pen.go.kr/yeyak/main.do" target="blank_">부산남부교육지원청</a></li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data: () => ({
    message: "sitemap.vue"
  }),
  methods: {},
  computed: {

  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/sitemap.vue